import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiKeysApi, APIKeyCreateRequest, APIKeyUpdateRequest } from '../api/apiKeys';

export const useApiKeyList = () => {
  return useQuery({
    queryKey: ['api-keys'],
    queryFn: () => apiKeysApi.list(),
  });
};

export const useApiKey = (keyId: string) => {
  return useQuery({
    queryKey: ['api-key', keyId],
    queryFn: () => apiKeysApi.get(keyId),
    enabled: !!keyId,
  });
};

export const useCreateApiKey = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: APIKeyCreateRequest) => apiKeysApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['api-keys'] });
    },
  });
};

export const useUpdateApiKey = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ keyId, data }: { keyId: string; data: APIKeyUpdateRequest }) => apiKeysApi.update(keyId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['api-keys'] });
    },
  });
};

export const useDeleteApiKey = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (keyId: string) => apiKeysApi.delete(keyId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['api-keys'] });
    },
  });
};
